(() => {
  if (window.accplusWelcomeVisit) return;

  const recordKey = 'accplus-welcome-first-visit-v1';
  const sessionKey = 'accplus-welcome-first-visit-session-v1';
  const lockName = 'accplus-welcome-first-visit-v1';
  const legacyKeys = {
    dismissed: 'accplus-welcome-offer-20260817-dismissed',
    converted: 'accplus-welcome-offer-20260817-converted'
  };
  // Restored tabs can retain sessionStorage after a browser restart.
  const visitWindow = 30 * 60 * 1000;
  const editor = window.Shopify?.designMode === true;
  let state = editor ? 'editor' : 'blocked';
  let owner = null;

  const write = (storage, key, value) => {
    storage.setItem(key, value);
    if (storage.getItem(key) !== value) throw new Error('Welcome visit storage was not saved');
  };
  const readRecord = () => {
    const raw = window.localStorage.getItem(recordKey);
    if (raw === null) return null;
    const record = JSON.parse(raw);
    if (!record || record.version !== 1) throw new Error('Unknown welcome visit record');
    if (['shown', 'returning', 'converted'].includes(record.state)) return record;
    if (record.state !== 'eligible' || typeof record.owner !== 'string' || !record.owner ||
        record.owner.length > 80 || !Number.isSafeInteger(record.startedAt) || record.startedAt <= 0) {
      throw new Error('Invalid welcome visit record');
    }
    return record;
  };
  const saveRecord = (record) => write(window.localStorage, recordKey, JSON.stringify(record));
  const knownVisitor = () => document.body?.dataset.welcomeKnownVisitor === 'true' ||
    window.localStorage.getItem(legacyKeys.dismissed) !== null ||
    window.localStorage.getItem(legacyKeys.converted) !== null;
  const stillEligible = (record) => record?.state === 'eligible' && record.owner === owner &&
    Date.now() >= record.startedAt && Date.now() - record.startedAt < visitWindow;
  const locked = (task) => {
    if (editor || typeof window.navigator?.locks?.request !== 'function') {
      // A storage read/write fallback cannot prevent two simultaneous tab claims.
      if (!editor) state = 'unavailable';
      return Promise.resolve(false);
    }
    return window.navigator.locks.request(lockName, { mode: 'exclusive' }, task).catch(() => {
      state = 'unavailable';
      return false;
    });
  };

  const ready = locked(() => {
    const record = readRecord();
    const sessionOwner = window.sessionStorage.getItem(sessionKey);
    if (knownVisitor()) {
      const converted = record?.state === 'converted' ||
        window.localStorage.getItem(legacyKeys.converted) === 'true';
      saveRecord({ version: 1, state: converted ? 'converted' : 'returning' });
      return false;
    }
    if (record) {
      owner = sessionOwner;
      state = stillEligible(record) ? 'eligible' : 'blocked';
      return state === 'eligible';
    }
    if (sessionOwner !== null || typeof window.crypto?.randomUUID !== 'function') return false;
    owner = window.crypto.randomUUID();
    write(window.sessionStorage, sessionKey, owner);
    saveRecord({ version: 1, state: 'eligible', owner, startedAt: Date.now() });
    state = 'eligible';
    return true;
  });

  const remember = async (converted) => {
    await ready;
    if (editor) return;
    const update = () => {
      state = 'blocked';
      write(window.localStorage, legacyKeys[converted ? 'converted' : 'dismissed'],
        converted ? 'true' : String(Date.now()));
      const record = readRecord();
      saveRecord({ version: 1, state: converted || record?.state === 'converted' ? 'converted' : 'shown' });
    };
    try {
      if (typeof window.navigator?.locks?.request === 'function') await locked(update);
      else update();
    } catch {
      state = 'unavailable';
    }
  };

  window.accplusWelcomeVisit = Object.freeze({
    async requestAutoOpen(open) {
      await ready;
      if (state !== 'eligible' || typeof open !== 'function') return false;
      return locked(() => {
        const record = readRecord();
        if (knownVisitor() || !stillEligible(record)) {
          state = 'blocked';
          return false;
        }
        saveRecord({ version: 1, state: 'shown' });
        state = 'blocked';
        if (open() === false) {
          saveRecord(record);
          state = 'eligible';
          return false;
        }
        return true;
      });
    },
    recordFormSuccess: () => remember(true),
    recordDismissal: () => remember(false)
  });
})();
